import { render, staticRenderFns } from "./TagLibraryTab.vue?vue&type=template&id=2fc9d3b7&scoped=true"
import script from "./TagLibraryTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagLibraryTab.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TagLibraryTab.vue?vue&type=style&index=0&id=2fc9d3b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc9d3b7",
  null
  
)

export default component.exports